<template>
  <div v-if="alert" class="d-print-none">
    <div
      :type="alert.getAlertType"
      class="alert alert--rounded"
      :class="[
        { 'alert--paragraph': !isFullwidth },
        alert.class,
        { 'alert--show-icon alert--big-icon': showIcon }
      ]"
      role="alert"
      aria-atomic="true"
      :aria-label="alert.ariaLabel">
      <div>
        <h4 v-if="alert.title" class="alert-heading">
          {{ alert.title }}
        </h4>

        <p
          v-if="alert.text"
          :class="[
            { 'alert-text': !isFullwidth },
            { 'alert-text-full text-dark': isFullwidth }
          ]">
          {{ alert.text }}
        </p>
      </div>
      <div v-if="showClose">
        <AtomButton
          appearance="unstyled"
          class="alert-close"
          action-text="Luk"
          @click="emitCloseAlert()" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { BaseAlertDataObject } from '@/types/models/alert.model';

defineProps({
  alert: {
    type: Object as PropType<BaseAlertDataObject>,
    required: true
  },
  isFullwidth: {
    type: Boolean,
    default: false
  },
  showIcon: {
    type: Boolean,
    default: false
  },
  showClose: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close']);

function emitCloseAlert() {
  emit('close');
}
</script>
<style lang="scss"></style>
